import styled from "@emotion/styled";
import CSAInput from "./CSAInput";

const FormItem = styled(CSAInput)`
  margin-bottom: 1rem;
  width: 25rem;
`;

export default FormItem;
